import { render, staticRenderFns } from "./SettingsAdServiceIntegrationsPages.vue?vue&type=template&id=4e7a6b88&scoped=true&"
import script from "./SettingsAdServiceIntegrationsPages.vue?vue&type=script&lang=ts&"
export * from "./SettingsAdServiceIntegrationsPages.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsAdServiceIntegrationsPages.vue?vue&type=style&index=0&id=4e7a6b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7a6b88",
  null
  
)

export default component.exports